module.exports = __webpack_public_path__ + "img/143.496ae166.jpg";